export const Logo = ({ className = "h-11 w-11" }) => (
  <img
    src="/assets/logo-official.jpg"
    alt="Logo Monte Yolli — Del Corazón de la Montaña"
    className={`${className} rounded-full object-cover ring-1 ring-pine/15`}
  />
);

export default Logo;
